var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    this.specificVo.beneGroup == "MEA" && this.lgType == 5
      ? _c("div", { staticClass: "form-row div-valign" }, [
          _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", [_vm._v("บัญชีแสดงสัญญา")]),
            _c("span", { staticClass: "required" }, [_vm._v("*")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.caNoExt,
                  expression: "caNoExt"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: true, max: 20 },
                  expression: "{required:true,max:20}"
                }
              ],
              staticClass: "form-control",
              class: { input: true, "is-danger": _vm.errors.has("caNoExt") },
              attrs: { name: "caNoExt", type: "text" },
              domProps: { value: _vm.caNoExt },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.caNoExt = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("caNoExt"),
                    expression: "errors.has('caNoExt')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก บัญชีแสดงสัญญา")]
            )
          ]),
          _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", [_vm._v("เครื่องวัดไฟฟ้าเลขที่")]),
            _c("span", { staticClass: "required" }, [_vm._v("*")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.meterNoExt,
                  expression: "meterNoExt"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: true, max: 20 },
                  expression: "{required:true,max:20}"
                }
              ],
              staticClass: "form-control",
              class: { input: true, "is-danger": _vm.errors.has("meterNoExt") },
              attrs: { name: "meterNoExt", type: "text" },
              domProps: { value: _vm.meterNoExt },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.meterNoExt = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("meterNoExt"),
                    expression: "errors.has('meterNoExt')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก เครื่องวัดไฟฟ้าเลขที่")]
            )
          ])
        ])
      : _vm._e(),
    this.specificVo.ctrNoFlag == "Y"
      ? _c("div", { staticClass: "form-row div-valign" }, [
          _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", [_vm._v(_vm._s(_vm.txtCtrNo))]),
            this.isRequiredCtrNo
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.ctrNoExt,
                  expression: "ctrNoExt"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredCtrNo },
                  expression: "{ required: this.isRequiredCtrNo }"
                }
              ],
              staticClass: "form-control",
              class: { input: true, "is-danger": _vm.errors.has("ctrNoExt") },
              attrs: {
                name: "ctrNoExt",
                "data-vv-as": "ข้อมูล",
                maxlength: "50",
                type: "text"
              },
              domProps: { value: _vm.ctrNoExt },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.ctrNoExt = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("ctrNoExt"),
                    expression: "errors.has('ctrNoExt')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก " + _vm._s(_vm.txtCtrNo))]
            )
          ])
        ])
      : _vm._e(),
    this.specificVo.ctrNameFlag == "Y"
      ? _c("div", { staticClass: "form-row div-valign" }, [
          _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", [_vm._v(_vm._s(_vm.txtCtrName))]),
            this.isRequiredCtrName
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.ctrNameExt,
                  expression: "ctrNameExt"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredCtrName },
                  expression: "{ required: this.isRequiredCtrName }"
                }
              ],
              staticClass: "form-control",
              class: { input: true, "is-danger": _vm.errors.has("ctrNameExt") },
              attrs: {
                name: "ctrNameExt",
                "data-vv-as": "ชื่อสัญญา",
                maxlength: "200",
                type: "text"
              },
              domProps: { value: _vm.ctrNameExt },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.ctrNameExt = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("ctrNameExt"),
                    expression: "errors.has('ctrNameExt')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก " + _vm._s(_vm.txtCtrName))]
            )
          ])
        ])
      : _vm._e(),
    this.specificVo.ctrDateFlag == "Y"
      ? _c("div", { staticClass: "form-row div-valign" }, [
          _c(
            "div",
            { staticClass: "form-group col-md-6" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.txtCtrDate)),
                this.isRequiredCtrDate
                  ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                  : _vm._e(),
                this.txtCtrDate.length < 17
                  ? _c("span", { staticClass: "text-white" }, [
                      _vm._v("         ")
                    ])
                  : _vm._e()
              ]),
              _c("date-picker", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: this.isRequiredCtrDate },
                    expression: "{ required: this.isRequiredCtrDate }"
                  }
                ],
                ref: "ctrDateExt",
                class: {
                  input: true,
                  "is-danger": _vm.errors.has("ctrDateExt")
                },
                attrs: {
                  name: "ctrDateExt",
                  format: "DD/MM/YYYY",
                  "data-vv-as": "ข้อมูล",
                  lang: "th",
                  placeholder: ""
                },
                model: {
                  value: _vm.ctrDateExt,
                  callback: function($$v) {
                    _vm.ctrDateExt = $$v
                  },
                  expression: "ctrDateExt"
                }
              }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("ctrDateExt"),
                      expression: "errors.has('ctrDateExt')"
                    }
                  ],
                  staticClass: "help is-danger"
                },
                [_vm._v("กรุณากรอก " + _vm._s(_vm.txtCtrDate))]
              )
            ],
            1
          )
        ])
      : _vm._e(),
    this.specificVo.beneRemarkFlag == "Y"
      ? _c("div", { staticClass: "form-row div-valign" }, [
          _c("div", { staticClass: "form-group col-md-12" }, [
            _c("label", [
              _vm._v("\n        " + _vm._s(_vm.labelBeneRemark) + "\n      ")
            ]),
            this.isRequiredBeneRemark
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.beneficiaryRemarkExt,
                  expression: "beneficiaryRemarkExt"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredBeneRemark },
                  expression: "{ required: this.isRequiredBeneRemark }"
                }
              ],
              staticClass: "form-control",
              class: {
                input: true,
                "is-danger": _vm.errors.has("beneficiaryRemarkExt")
              },
              attrs: {
                name: "beneficiaryRemarkExt",
                "data-vv-as": "ข้อมูล",
                maxlength: "500",
                type: "text"
              },
              domProps: { value: _vm.beneficiaryRemarkExt },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.beneficiaryRemarkExt = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("beneficiaryRemarkExt"),
                    expression: "errors.has('beneficiaryRemarkExt')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก " + _vm._s(_vm.labelBeneRemark))]
            )
          ])
        ])
      : _vm._e(),
    this.specificVo.dealerCodeFlag == "Y"
      ? _c("div", { staticClass: "form-row div-valign" }, [
          _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", [_vm._v(" " + _vm._s(_vm.labelDealerCode) + " ")]),
            this.isRequiredDealerCode
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.dealerCodeExt,
                  expression: "dealerCodeExt"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredDealerCode },
                  expression: "{ required: this.isRequiredDealerCode }"
                }
              ],
              staticClass: "form-control",
              class: {
                input: true,
                "is-danger": _vm.errors.has("dealerCodeExt")
              },
              attrs: {
                name: "dealerCodeExt",
                "data-vv-as": "ข้อมูล",
                maxlength: "500",
                type: "text"
              },
              domProps: { value: _vm.dealerCodeExt },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.dealerCodeExt = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("dealerCodeExt"),
                    expression: "errors.has('dealerCodeExt')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก " + _vm._s(_vm.labelDealerCode))]
            )
          ])
        ])
      : _vm._e(),
    this.specificVo.ctrDatePEAFlag == "Y"
      ? _c("div", { staticClass: "form-row div-valign" }, [
          _c(
            "div",
            { staticClass: "form-group col-md-6" },
            [
              _c("label", [_vm._v("สัญญาลงวันที่")]),
              this.isRequiredCtrDatePEA
                ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                : _vm._e(),
              _c("date-picker", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: this.isRequiredCtrDatePEA },
                    expression: "{ required: this.isRequiredCtrDatePEA }"
                  }
                ],
                ref: "ctrDatePEAExt",
                class: {
                  input: true,
                  "is-danger": _vm.errors.has("ctrDatePEAExt")
                },
                attrs: {
                  name: "ctrDatePEAExt",
                  format: "DD/MM/YYYY",
                  "data-vv-as": "สัญญาลงวันที่",
                  lang: "th",
                  placeholder: ""
                },
                model: {
                  value: _vm.ctrDatePEAExt,
                  callback: function($$v) {
                    _vm.ctrDatePEAExt = $$v
                  },
                  expression: "ctrDatePEAExt"
                }
              }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("ctrDatePEAExt"),
                      expression: "errors.has('ctrDatePEAExt')"
                    }
                  ],
                  staticClass: "help is-danger"
                },
                [_vm._v(_vm._s(_vm.errors.first("ctrDatePEAExt")))]
              )
            ],
            1
          )
        ])
      : _vm._e(),
    this.specificVo.lgDescription3Flag == "Y"
      ? _c("div", { staticClass: "form-row div-valign" }, [
          _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", [_vm._v(_vm._s(_vm.labelLgDescription3))]),
            this.isRequiredLgDescription3
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.lgDescription3Ext,
                  expression: "lgDescription3Ext"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredLgDescription3 },
                  expression: "{ required: this.isRequiredLgDescription3 }"
                }
              ],
              staticClass: "form-control",
              class: {
                input: true,
                "is-danger": _vm.errors.has("lgDescription3Ext")
              },
              attrs: {
                name: "lgDescription3Ext",
                "data-vv-as": "ชื่อสัญญาหลัก",
                maxlength: "500",
                type: "text"
              },
              domProps: { value: _vm.lgDescription3Ext },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.lgDescription3Ext = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("lgDescription3Ext"),
                    expression: "errors.has('lgDescription3Ext')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก " + _vm._s(_vm.labelLgDescription3))]
            )
          ])
        ])
      : _vm._e(),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.projectIdFlag == "Y"
        ? _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", { staticStyle: { display: "contents" } }, [
              _vm._v(_vm._s(_vm.labelProjectId))
            ]),
            this.isRequiredProjectId
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.projectIdExt,
                  expression: "projectIdExt"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredProjectId },
                  expression: "{ required: this.isRequiredProjectId }"
                }
              ],
              staticClass: "form-control",
              class: {
                input: true,
                "is-danger": _vm.errors.has("projectIdExt")
              },
              attrs: {
                name: "projectIdExt",
                "data-vv-as": "เลขที่โครงการ",
                maxlength: "50",
                type: "text"
              },
              domProps: { value: _vm.projectIdExt },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.projectIdExt = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("projectIdExt"),
                    expression: "errors.has('projectIdExt')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก " + _vm._s(_vm.labelProjectId))]
            )
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.projectNameFlag == "Y"
        ? _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", { staticStyle: { display: "contents" } }, [
              _vm._v(_vm._s(_vm.labelProjectName))
            ]),
            this.isRequiredProjectName
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.projectNameExt,
                  expression: "projectNameExt"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: _vm.isRequiredProjectName },
                  expression: "{ required: isRequiredProjectName }"
                }
              ],
              staticClass: "form-control",
              class: {
                input: true,
                "is-danger": _vm.errors.has("projectNameExt")
              },
              attrs: {
                name: "projectNameExt",
                "data-vv-as": "ข้อมูล",
                maxlength: "150",
                type: "text"
              },
              domProps: { value: _vm.projectNameExt },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.projectNameExt = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("projectNameExt"),
                    expression: "errors.has('projectNameExt')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก " + _vm._s(_vm.labelProjectName))]
            )
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.productTypeFlag == "Y"
        ? _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", { staticStyle: { display: "contents" } }, [
              _vm._v(_vm._s(_vm.labelProductType))
            ]),
            this.isRequiredProductType
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.productTypeExt,
                  expression: "productTypeExt"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredProductType },
                  expression: "{ required: this.isRequiredProductType }"
                }
              ],
              staticClass: "form-control",
              class: {
                input: true,
                "is-danger": _vm.errors.has("productTypeExt")
              },
              attrs: {
                name: "productTypeExt",
                "data-vv-as": "ข้อมูล",
                maxlength: "500",
                type: "text"
              },
              domProps: { value: _vm.productTypeExt },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.productTypeExt = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("productTypeExt"),
                    expression: "errors.has('productTypeExt')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก " + _vm._s(_vm.labelProductType))]
            )
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.collectionPhaseFlag == "Y"
        ? _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", { staticStyle: { display: "contents" } }, [
              _vm._v("งวดเงินทั้งหมด(เริ่มต้น/สิ้นสุด)")
            ]),
            this.isRequiredCollectionPhase
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.collectionPhaseExt,
                  expression: "collectionPhaseExt"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredCollectionPhase },
                  expression: "{ required: this.isRequiredCollectionPhase }"
                }
              ],
              staticClass: "form-control",
              class: {
                input: true,
                "is-danger": _vm.errors.has("collectionPhaseExt")
              },
              attrs: {
                name: "collectionPhaseExt",
                "data-vv-as": "งวดเงินทั้งหมด(เริ่มต้น/สิ้นสุด)",
                maxlength: "500",
                type: "text"
              },
              domProps: { value: _vm.collectionPhaseExt },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.collectionPhaseExt = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("collectionPhaseExt"),
                    expression: "errors.has('collectionPhaseExt')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v(_vm._s(_vm.errors.first("collectionPhaseExt")))]
            )
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.projectBudgetAmtFlag == "Y"
        ? _c(
            "div",
            { staticClass: "form-group col-md-6" },
            [
              _c("label", { staticStyle: { display: "contents" } }, [
                _vm._v(_vm._s(_vm.labelProjectBudgetAmt))
              ]),
              this.isRequiredProjectBudgetAmt
                ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                : _vm._e(),
              _c("vue-numeric", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: this.isRequiredProjectBudgetAmt },
                    expression: "{ required: this.isRequiredProjectBudgetAmt }"
                  }
                ],
                staticClass: "form-control",
                class: {
                  input: true,
                  "is-danger": _vm.errors.has("projectBudgetAmtExt")
                },
                attrs: {
                  name: "projectBudgetAmtExt",
                  precision: 2,
                  "data-vv-as": "มูลค่าขั้นต่ำของคลื่นความถี่"
                },
                on: {
                  keypress: function($event) {
                    return _vm.isNumber($event)
                  }
                },
                model: {
                  value: _vm.projectBudgetAmtExt,
                  callback: function($$v) {
                    _vm.projectBudgetAmtExt = $$v
                  },
                  expression: "projectBudgetAmtExt"
                }
              }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("projectBudgetAmtExt"),
                      expression: "errors.has('projectBudgetAmtExt')"
                    }
                  ],
                  staticClass: "help is-danger"
                },
                [_vm._v(_vm._s(_vm.errors.first("projectBudgetAmtExt")))]
              )
            ],
            1
          )
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.seqNoFlag == "Y"
        ? _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", { staticStyle: { display: "contents" } }, [
              _vm._v("ลำดับผู้ยื่นคำขอตามคลื่นความถี่")
            ]),
            this.isRequiredSeqNo
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.seqNoExt,
                  expression: "seqNoExt"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredSeqNo },
                  expression: "{ required: this.isRequiredSeqNo }"
                }
              ],
              staticClass: "form-control",
              class: { input: true, "is-danger": _vm.errors.has("seqNoExt") },
              attrs: {
                name: "seqNoExt",
                "data-vv-as": "ลำดับผู้ยื่นคำขอตามคลื่นความถี่",
                maxlength: "500",
                type: "text"
              },
              domProps: { value: _vm.seqNoExt },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.seqNoExt = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("seqNoExt"),
                    expression: "errors.has('seqNoExt')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v(_vm._s(_vm.errors.first("seqNoExt")))]
            )
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.bidExpireDateFlag == "Y"
        ? _c(
            "div",
            { staticClass: "form-group col-md-6" },
            [
              _c("label", [_vm._v(_vm._s(_vm.labelBidExpireDate))]),
              this.isRequiredBidExpireDate
                ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                : _vm._e(),
              _c("date-picker", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: this.isRequiredBidExpireDate },
                    expression: "{ required: this.isRequiredBidExpireDate }"
                  }
                ],
                ref: "bidExpireDateExt",
                class: {
                  input: true,
                  "is-danger": _vm.errors.has("bidExpireDateExt")
                },
                attrs: {
                  name: "bidExpireDateExt",
                  format: "DD/MM/YYYY",
                  "data-vv-as": "วันที่สิ้นสุดการวางหลักประกัน",
                  lang: "th",
                  placeholder: ""
                },
                model: {
                  value: _vm.bidExpireDateExt,
                  callback: function($$v) {
                    _vm.bidExpireDateExt = $$v
                  },
                  expression: "bidExpireDateExt"
                }
              }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("bidExpireDateExt"),
                      expression: "errors.has('bidExpireDateExt')"
                    }
                  ],
                  staticClass: "help is-danger"
                },
                [_vm._v("กรุณากรอก " + _vm._s(_vm.labelBidExpireDate))]
              )
            ],
            1
          )
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.guaranteePriceAmtFlag == "Y"
        ? _c(
            "div",
            { staticClass: "form-group col-md-12" },
            [
              _c("label", [_vm._v(_vm._s(_vm.labelGuaranteePriceAmt))]),
              this.isRequiredGuaranteePriceAmt
                ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                : _vm._e(),
              _c("vue-numeric", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required: this.isRequiredGuaranteePriceAmt,
                      min_value: 0.01
                    },
                    expression:
                      "{ required: this.isRequiredGuaranteePriceAmt, min_value: 0.01}"
                  }
                ],
                staticClass: "form-control",
                class: {
                  input: true,
                  "is-danger": _vm.errors.has("guaranteePriceAmtExt")
                },
                attrs: {
                  name: "guaranteePriceAmtExt",
                  precision: 2,
                  "data-vv-as": "จํานวนเงินในการวางประกัน"
                },
                on: {
                  keypress: function($event) {
                    return _vm.isNumber($event)
                  }
                },
                model: {
                  value: _vm.guaranteePriceAmtExt,
                  callback: function($$v) {
                    _vm.guaranteePriceAmtExt = $$v
                  },
                  expression: "guaranteePriceAmtExt"
                }
              }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("guaranteePriceAmtExt"),
                      expression: "errors.has('guaranteePriceAmtExt')"
                    }
                  ],
                  staticClass: "help is-danger"
                },
                [
                  _vm._v(
                    _vm._s(_vm.labelGuaranteePriceAmt) + " ต้องมีค่ามากกว่า 0"
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.percentageFlag == "Y"
        ? _c(
            "div",
            { staticClass: "form-group col-md-6" },
            [
              _c("label", [_vm._v(_vm._s(_vm.labelPercentage))]),
              this.isRequiredPercentage
                ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                : _vm._e(),
              _c("vue-numeric", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: this.isRequiredPercentage },
                    expression: "{ required: this.isRequiredPercentage }"
                  }
                ],
                staticClass: "form-control",
                class: {
                  input: true,
                  "is-danger": _vm.errors.has("percentageExt")
                },
                attrs: {
                  name: "percentageExt",
                  separator: ",",
                  precision: 2,
                  "data-vv-as": "อัตราร้อยละ ในการวางหลักประกัน"
                },
                on: {
                  keypress: function($event) {
                    return _vm.isNumber($event)
                  },
                  blur: function($event) {
                    return _vm.validPercent()
                  }
                },
                model: {
                  value: _vm.percentageExt,
                  callback: function($$v) {
                    _vm.percentageExt = $$v
                  },
                  expression: "percentageExt"
                }
              }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("percentageExt"),
                      expression: "errors.has('percentageExt')"
                    }
                  ],
                  staticClass: "help is-danger"
                },
                [_vm._v("กรุณากรอก " + _vm._s(_vm.labelPercentage))]
              )
            ],
            1
          )
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.contractPeriodFlag == "Y"
        ? _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", [_vm._v("งวดที่ประกันผลงาน")]),
            this.isRequiredContractPeriod
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.contractPeriod,
                  expression: "contractPeriod"
                }
              ],
              staticClass: "form-control",
              class: {
                input: true,
                "is-danger": _vm.errors.has("contractPeriod")
              },
              attrs: {
                name: "contractPeriod",
                "data-vv-as": "งวดที่ประกันผลงาน",
                maxlength: "500",
                type: "text"
              },
              domProps: { value: _vm.contractPeriod },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.contractPeriod = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("contractPeriod"),
                    expression: "errors.has('contractPeriod')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v(_vm._s(_vm.errors.first("contractPeriod")))]
            )
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.advancePaymentAmtFlag == "Y"
        ? _c(
            "div",
            { staticClass: "form-group col-md-6" },
            [
              _c("label", [_vm._v("เงินค่าจ้างล่วงหน้า")]),
              this.isRequiredAdvancePaymentAmtAmt
                ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                : _vm._e(),
              _c("vue-numeric", {
                staticClass: "form-control",
                class: {
                  input: true,
                  "is-danger": _vm.errors.has("advancePaymentAmtExt")
                },
                attrs: {
                  name: "advancePaymentAmtExt",
                  precision: 2,
                  "data-vv-as": "เงินค่าจ้างล่วงหน้า"
                },
                on: {
                  keypress: function($event) {
                    return _vm.isNumber($event)
                  }
                },
                model: {
                  value: _vm.advancePaymentAmtExt,
                  callback: function($$v) {
                    _vm.advancePaymentAmtExt = $$v
                  },
                  expression: "advancePaymentAmtExt"
                }
              }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("advancePaymentAmtExt"),
                      expression: "errors.has('advancePaymentAmtExt')"
                    }
                  ],
                  staticClass: "help is-danger"
                },
                [_vm._v(_vm._s(_vm.errors.first("advancePaymentAmtExt")))]
              )
            ],
            1
          )
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.projectOwnerFlag == "Y"
        ? _c("div", { staticClass: "form-group col-md-12" }, [
            _c("label", [_vm._v(_vm._s(_vm.labelProjectOwner))]),
            this.isRequiredProjectOwner
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.projectOwnerExt,
                  expression: "projectOwnerExt"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredProjectOwner },
                  expression: "{ required: this.isRequiredProjectOwner }"
                }
              ],
              staticClass: "form-control",
              class: {
                input: true,
                "is-danger": _vm.errors.has("projectOwnerExt")
              },
              attrs: {
                name: "projectOwnerExt",
                "data-vv-as": "ข้อมูล",
                maxlength: "500",
                type: "text"
              },
              domProps: { value: _vm.projectOwnerExt },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.projectOwnerExt = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("projectOwnerExt"),
                    expression: "errors.has('projectOwnerExt')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก " + _vm._s(_vm.labelProjectOwner))]
            )
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.manyCtrNoFlag == "Y"
        ? _c("div", { staticClass: "form-group col-md-12" }, [
            _c("label", [_vm._v(_vm._s(_vm.labelManyCtrNo))]),
            this.isRequiredManyCtrNo
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.manyCtrNoExt,
                  expression: "manyCtrNoExt"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredManyCtrNo },
                  expression: "{ required: this.isRequiredManyCtrNo}"
                }
              ],
              staticClass: "form-control",
              class: {
                input: true,
                "is-danger": _vm.errors.has("manyCtrNoExt")
              },
              attrs: {
                name: "manyCtrNoExt",
                "data-vv-as": "เลขที่สัญญา ตั้งแต่ฉบับที่ 2",
                maxlength: "400",
                type: "text"
              },
              domProps: { value: _vm.manyCtrNoExt },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.manyCtrNoExt = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("manyCtrNoExt"),
                    expression: "errors.has('manyCtrNoExt')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก " + _vm._s(_vm.labelManyCtrNo))]
            )
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.manyCtrDateFlag == "Y"
        ? _c("div", { staticClass: "form-group col-md-12" }, [
            _c("label", [_vm._v(_vm._s(_vm.labelManyCtrDate))]),
            this.isRequiredManyCtrDate
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.manyCtrDateExt,
                  expression: "manyCtrDateExt"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredManyCtrDate },
                  expression: "{ required: this.isRequiredManyCtrDate}"
                }
              ],
              staticClass: "form-control",
              class: {
                input: true,
                "is-danger": _vm.errors.has("manyCtrDateExt")
              },
              attrs: {
                name: "manyCtrDateExt",
                "data-vv-as":
                  "สัญญาลงวันที่ ตั้งแต่ฉบับที่ 2: (yyyy-mm-dd,yyyy-mm-dd,....)",
                maxlength: "400",
                type: "text"
              },
              domProps: { value: _vm.manyCtrDateExt },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.manyCtrDateExt = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("manyCtrDateExt"),
                    expression: "errors.has('manyCtrDateExt')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก " + _vm._s(_vm.labelManyCtrDate))]
            )
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.manyCtrNameFlag == "Y"
        ? _c("div", { staticClass: "form-group col-md-12" }, [
            _c("label", [_vm._v(_vm._s(_vm.labelManyCtrName))]),
            this.isRequiredManyCtrName
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.manyCtrNameExt,
                  expression: "manyCtrNameExt"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredManyCtrName },
                  expression: "{ required: this.isRequiredManyCtrName }"
                }
              ],
              staticClass: "form-control",
              class: {
                input: true,
                "is-danger": _vm.errors.has("manyCtrNoExt")
              },
              attrs: {
                name: "manyCtrNameExt",
                "data-vv-as":
                  "ชื่อสัญญาที่ค้ำประกันเพิ่มเติม กรณีมีสัญญาที่ค้ำประกันตั้งแต่สองฉบับขึ้นไป",
                maxlength: "500",
                type: "text"
              },
              domProps: { value: _vm.manyCtrNameExt },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.manyCtrNameExt = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("manyCtrNameExt"),
                    expression: "errors.has('manyCtrNameExt')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก " + _vm._s(_vm.labelManyCtrName))]
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }